import isNotNil from "ramda-extension/es/isNotNil";
import filterChildren from '../filterChildren';
export default filterChildren(isNotNil);
